export const basePath = 'https://viewer.agos.com.tr';
export const parentDomain = 'https://www.agos.com.tr/';
export const BASE_TOKEN_NAME = 'VIEWER_SECURE_TOKEN';
